import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = { successDuration: { type: Number, default: 2000 } }

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      this.#showFeedback()
    })
  }

  #showFeedback() {
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = "¡Copiado!"
    this.buttonTarget.disabled = true

    setTimeout(() => {
      this.buttonTarget.textContent = original
      this.buttonTarget.disabled = false
    }, this.successDurationValue)
  }
}
